<template>
  <v-row justify="center" align="start">
    <v-col class="pt-10" cols="12" align="center">
      <span class="text-h2 font-weight-bold grey--text text--darken-3 ada-ignore-text-size">
        {{ $t('default') }}
      </span>
    </v-col>
    <v-col cols="10" class="py-2">
      <v-row class="fill-height mt-6 mb-8" align="center" justify="center">
        <v-col align="center" :cols="menu.col" v-for="(page, index) in $t('homepages')" :key="index" class="mb-2">
          <v-card @click="goto(page)" @keydown.enter.prevent="goto(page)" @keydown.space.prevent="goto(page)" class="menuItem d-flex flex-column align-center justify-center"
            :width="menu.width" :height="menu.height" elevation="5" color="primary">
            <v-img :src="page.menuIcon.url" :width="menu.imageWidth" contain>
            </v-img>
            <v-card-text class="text-h5 white--text font-weight-bold">
              {{ page.menuName }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-divider class="pb-6 mx-10"></v-divider>
      <languageBar></languageBar>
    </v-col>
  </v-row>
</template>

<script>
import languageBar from '@/components/languageBar'
import { mapGetters } from 'vuex'

export default {
  name: 'menuMatrix',
  components: {
    languageBar
  },
  data() {
    return {
      menu: {
        height: null,
        width: null,
        col: null,
        imageWidth: null
      }
    }
  },
  computed: {
    ...mapGetters(['getCMSlink', 'getTouchCount', 'isUserLooking'])
  },
  methods: {
    goto(page) {
      if (page.pageType.length !== 0) {
        console.log('Selected Module: ', page.pageType[0])
        switch (page.pageType[0].__typename) {
          case 'ComponentHomepageNavigation':
            this.$router.push('/' + page.pageType[0].pathName.toLowerCase());
            this.$store.commit('setPageHeader', page.pageType[0].pageHeader)
            this.$store.commit('setQnaKeyword', '')

            // To start session using touch - when no face detected
            if (!this.isUserLooking) {
              this.$store.commit('setTouchCount', this.getTouchCount + 1)
              if (this.getTouchCount === 1) {
                // start time
                this.$store.commit('setStartUserSession', new Date())
                this.$store.dispatch('addInteractionToPostgres', { actionType: 'Session Started', actionPayload: { recognitionType: 'Touch' } })
                //session start object
                this.$store.commit('setTouchRequest', {
                  module: 'Default',
                  action: 'Touch Detected',
                  response: 'User Session Started - Touch Detected',
                  timeStamp: new Date(),
                  requestType: 'Session'
                })
              }
            }

            // Will be called irrespective of Touch Count
            this.$store.commit('setTouchRequest', {
              module: 'Home Page',
              action: 'navigate',
              response: page.pageType[0].pathName,
              timeStamp: new Date(),
              requestType: 'Touch'
            })
            this.$store.dispatch('addInteractionToPostgres', { actionType: 'Interaction', actionPayload: { module: 'Home Page', navigateFrom: 'Home Page', navigateTo: page.pageType[0].pathName, interactionType: 'Touch', elementContent: page.pageType[0].pathName } })

            this.$store.commit('setDefaultBubbleText', true)
            this.$store.dispatch('avatarSpeak', page.speech)
            break;
          case 'ComponentHomepageDialogBox':
            break;
          default:
            break;
        }
      }

    },
  },
  mounted() {
    console.log('Homepage Data: ', this.$i18n.t('homepages').length)
    if (this.$i18n.t('homepages').length <= 4) {
      this.menu = {
        height: 270,
        width: 280,
        col: 5,
        imageWidth: "45%"
      }
      console.log('Bigger Size')
    } else if (this.$i18n.t('homepages').length <= 6) {
      this.menu = {
        height: 260,
        width: 275,
        col: 4,
        imageWidth: "45%"
      }
    }
  }
}
</script>

<style>
.menuItem {
  border: solid #6b1530 !important;
  border-radius: 20px !important;
}

.footer {
  bottom: 0 !important;
}
</style>
<i18n>
  {
    "en": {
        "default": "How Can I Help You Today?"
      },
    "es":{
        "default": "¿Le puedo ayudar en algo?"
      }
  }
</i18n>